import React from 'react';
import './footer.css';
import { useTranslation } from '../../contexts/TranslationContext';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <a href="#top" className="footer__logo">{t('footer.name')}</a>
      <ul className="permalinks">
        <li><a href="#top">{t('footer.home')}</a></li>
        <li><a href="#about">{t('footer.about')}</a></li>
        <li><a href="#services">{t('footer.skills')}</a></li>
        <li><a href="#portfolio">{t('footer.portfolio')}</a></li>
        <li><a href="#contact">{t('footer.contact')}</a></li>
      </ul>
      <div className="footer__copyright">
        <small>&copy; 2022-2025 {t('footer.name')} - {t('footer.copyright')}</small>
        <small className="footer__credits">{t('footer.credits')}</small>
      </div>
    </footer>
  );
};

export default Footer;